module.exports = {"id":"221121","name":"Dario Rodríguez","rating":"72","photo":"./data/images/photos/4/221121.png","club":{"name":"Deportivo Pasto","logo":"./data/images/clubs/DeportivoPasto.png"},"positions":["BU","MD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DarioRodriguez0.json
// module id = 975
// module chunks = 0